import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import {LogErrorRequestType, LogErrorResponseType} from "@/api/types/LogError.type";

export const siteApi = createApi({
    reducerPath: "siteApi",
    baseQuery: fetchBaseQuery({
        baseUrl: "",
        headers: {
            "X-Requested-With": "XMLHttpRequest",
        },
    }),
    endpoints: (builder) => ({
        logError: builder.query<LogErrorResponseType, LogErrorRequestType>({
            query: (body) => ({
                url: '/ajax/log-error',
                method: 'POST',
                body,
            }),
            onQueryStarted: async (request, {queryFulfilled}) => {
                // eslint-disable-next-line no-console
                console.error(request.errorMessage, request)
                await queryFulfilled
            },
        }),
    }),
})

export const {
    useLazyLogErrorQuery,
} = siteApi